<template>
	<div class="offline">
		<!-- 顶部导航 -->
		<div class="nav" style="border: none;">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<div>售后服务</div>
			<span></span>
		</div>
		<div class="cotent">
			<!-- 填写内容 -->
			<div class="main">
				<div style="margin-top: 1rem;">
					<van-tabs style="width: 95%; border-radius: 0.8rem; margin: auto;" line-width=61px @click="Reset" v-model="activeName">
						<van-tab title="我要维修" name="1" van-icon>
							<div class="repair">
								<!-- 上传图纸 -->
								<van-cell-group class="main_froms">
									<van-cell is-link title="维修日期" :value="date" @click="show = true"></van-cell>
									<van-calendar v-model="show" :min-date="minDate" @confirm="onConfirm" />
									<div slot="default" class="default">
										<div class="p">维修家具拍照
										</div>
										<van-uploader :after-read="subCamera" v-model="fileList" :max-count="2" />
									</div>
									<div slot="default" class="default" style="padding: 0.4rem 0 0 2.2rem;">
										<div class="p">上传合同
										</div>
										<van-uploader :after-read="subCamera1" v-model="fileLists" :max-count="2" />
									</div>
									<div class="pos">备注信息：
									</div>
									<van-field v-model="message" style="background-color: #f7f8fa; border-radius: 0.8rem;" rows="1" type="textarea"
									 maxlength="500" placeholder="请详细说明需要维修的家具情况" />

								</van-cell-group>
								<van-cell-group class="main_from">
									<van-field v-model="user" clearable label="联系人" type="text" placeholder="请输入联系人" />
									<van-field v-model="tel" clearable label="联系电话" type="number" placeholder="请输入手机号" />
									<van-field clearable label="选择城市">
										<van-cell class="shurulan" style="height: 2rem;" slot="input" :title="selectaddress" is-link @click="select=true" />
									</van-field>
									<van-field v-model="address" clearable label="详细地址" type="text" placeholder="请输入联系地址" />
									<div class="anniu">
										<van-button @click="Reset">重置</van-button>
										<van-button color="#f1452f" @click="msg">提交</van-button>
									</div>
								</van-cell-group>
								<div class="xiabianj">

								</div>
							</div>
						</van-tab>
						<van-tab title="我要换货" name="2">
							<div class="repair">
								<!-- 上传图纸 -->
								<van-cell-group class="main_froms">
									<van-cell is-link title="换货日期" :value="date" @click="show = true"></van-cell>
									<van-calendar v-model="show" :min-date="minDate" @confirm="onConfirm" />
									<div slot="default" class="default">
										<div class="p">更换家具拍照
											<!-- <span class="tips">(为了帮您更好的解决问题，请上传需维修家具照片)</span> -->
										</div>
										<van-uploader :after-read="subCamera" v-model="fileList" :max-count="2" />
									</div>
									<div slot="default" class="default" style="padding: 0.4rem 0 0 2.2rem;">
										<div class="p">上传合同
											<!-- <span class="tips">(为了帮您更好的解决问题，请上传家具租赁合同照片)</span> -->
										</div>
										<van-uploader :after-read="subCamera1" v-model="fileLists" :max-count="2" />
									</div>

									<div class="pos">备注信息：
									</div>
									<van-field v-model="message" style="background-color: #f7f8fa; border-radius: 0.8rem;" rows="1" type="textarea"
									 maxlength="500" placeholder="请详细说明需要更换家具的原由" />

								</van-cell-group>
								<van-cell-group class="main_from">
									<van-field v-model="user" clearable label="联系人" type="text" placeholder="请输入联系人" />
									<van-field v-model="tel" clearable label="联系电话" type="number" placeholder="请输入手机号" />
									<van-field clearable label="选择城市">
										<van-cell class="shurulan" style="height: 2rem;" slot="input" :title="selectaddress" is-link @click="select=true" />
									</van-field>
									<van-field v-model="address" clearable label="详细地址" type="text" placeholder="请输入联系地址" />
									<div class="anniu">
										<van-button @click="Reset">重置</van-button>
										<van-button color="#f1452f" @click="msg">提交</van-button>
									</div>
								</van-cell-group>
								<div class="xiabianj">

								</div>
							</div>
						</van-tab>
						<van-tab title="我要退租" name="3">
							<div class="cancellation">
								<!-- 上传图纸 -->
								<van-cell-group class="main_froms">
									<van-cell is-link title="退租日期" :value="date" @click="show = true"></van-cell>
									<van-calendar v-model="show" :min-date="maxDate" @confirm="onConfirm" />
									<van-field v-model="contract_number" clearable label="合同编号" type="text" placeholder="请输入合同编号" />
									<div slot="default" class="default">
										<div class="p">上传合同</div>
										<van-uploader :after-read="subCamera1" v-model="fileLists" :max-count="2" />
									</div>
									<div slot="default" class="default" style="padding: 0.4rem 0 0 2.2rem;">
										<div class="p">上传租赁清单
											<!-- 										<span class="tips">(为了帮您更好的解决问题，请上传产品清单照片)</span> -->
										</div>
										<van-uploader :after-read="subCamera" v-model="fileList" :max-count="2" />
									</div>
									<div class="pos">备注信息：
									</div>
									<van-field v-model="message" style="background-color: #f7f8fa; border-radius: 0.8rem;" rows="1" type="textarea"
									 maxlength="500" placeholder="请详细说明退租的原由，我们好进一步改进" />

								</van-cell-group>
								<van-cell-group class="main_from">
									<van-field v-model="user" clearable label="联系人" type="text" placeholder="请输入联系人" />
									<van-field v-model="tel" clearable label="联系电话" type="number" placeholder="请输入手机号" />
									<van-field clearable label="选择城市">
										<van-cell class="shurulan" style="height: 2rem;" slot="input" :title="selectaddress" is-link @click="select=true" />
									</van-field>
									<van-field v-model="address" clearable label="详细地址" type="text" placeholder="请输入联系地址" />
									<div class="anniu">
										<van-button @click="Reset">重置</van-button>
										<van-button color="#f1452f" @click="msg1">提交</van-button>
									</div>
								</van-cell-group>
								<div class="xiabianj">

								</div>
							</div>
						</van-tab>
					</van-tabs>
				</div>
				<!-- 城市选择 -->
				<van-popup v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
					<van-area :area-list="areaList" @confirm="areaOk" @cancel="select=false" />
				</van-popup>
			</div>
			<!-- 提交跳转页面 -->
			<van-dialog v-model="showl" confirmButtonColor="#f1452f" theme="round-button" width="94%" :show-confirm-button=false>
				<img src="../../assets/shouhoutijiao_03.png" style="width: 40%;  margin: 5rem auto;" />
				<p>您的订单已经提交，正在为您安排中...</p>
				<van-button type="primary" style="width: 70%; border-radius: 2rem;" color="#f1452f" @click="tiaozhuan">完成</van-button>
				<div style="height: 2rem;"></div>
			</van-dialog>
		</div>
	</div>
	</div>
</template>

<script>
	import areaList from "@/assets/js/area.js"

	export default {
		data() {
			return {
				areaList,
				activeName: '1',
				tel: '',
				user: '',
				address: '',
				time: '',
				fileList: [],
				fileLists: [],
				annex: [],
				annexs: [],
				contract_number: '',
				showl: false,
				message: '',
				select: false,
				selectaddress: '点击选择城市',
				province: '',
				city: '',
				area: '',
				date: '点击选择日期',
				show: false,
				minDate: new Date(),
				maxDate: new Date(),
			}
		},
		created() {
			let nowDate = new Date()
			var year = nowDate.getFullYear()
			var month = nowDate.getMonth()
			var day = nowDate.getDate()
			this.minDate = new Date(year, month, day + 1)
			this.maxDate = new Date(year, month, day + 7)
		},
		methods: {
			// 选择时间
			formatDate(date) {
				return `${date.getMonth() + 1}/${date.getDate()}`;
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS)).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ").replace(/上午/g, "").replace(
					'/', "-").replace('/', "-");
			},
			onConfirm(date) {
				this.show = false;
				var snr = date.getTime();
				this.getLocalTime(snr);
				this.date = this.getLocalTime(snr).split(" ")[0]
			},
			// 上传附件1
			subCamera(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			// 上传附件2
			subCamera1(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annexs.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			// 维修以及换货表单验证以及提交
			msg() {
				var that = this;
				if (that.tel == '') {
					that.$toast('请输入手机号');
					return false;
				}
				if (that.user == '') {
					that.$toast('联系人不能为空');
					return false;
				}
				if (that.address == '') {
					that.$toast('地址为空');
					return false;
				}
				if (that.date == '') {
					that.$toast('请选择正确时间');
					return false;
				}
				const toast = that.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '提交中',
					loadingType: 'spinner'
				});

				that.$axios.post(baseUrl + '/mobile/server/serverAdd', {
					name: that.user,
					tel: that.tel,
					time: that.date,
					address: this.selectaddress + that.address,
					message: that.message,
					image: that.annex,
					contract_image: that.annexs,
					token: localStorage.getItem('Authorization'),
					type: this.activeName,
					province: this.province,
					city: this.city,
					area: this.area,
				}).then(function(res) {
					console.log(res)
					if (res.data.code == 19) {
						console.log(res)
						that.$toast(res.data.msg);
						that.showl = true;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			// 退租表单验证以及提交
			msg1() {
				var that = this;
				if (that.tel == '') {
					that.$toast('请输入手机号');
					return false;
				}
				if (that.user == '') {
					that.$toast('联系人不能为空');
					return false;
				}
				if (that.address == '') {
					that.$toast('产品清单不能为空');
					return false;
				}
				if (that.contract_number == '') {
					that.$toast('合同编号不能为空');
					return false;
				}

				const toast = that.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '提交中',
					loadingType: 'spinner'
				});

				that.$axios.post(baseUrl + '/mobile/server/backLeaseAdd', {
					name: that.user,
					tel: that.tel,
					time: that.date,
					address: this.selectaddress + that.address,
					contract_number: that.contract_number,
					image: that.annex,
					contract_image: that.annexs,
					message: that.message,
					token: localStorage.getItem('Authorization'),
					province: this.province,
					city: this.city,
					area: this.area,
				}).then(function(res) {
					if (res.data.code == 19) {
						that.$toast(res.data.msg);
						that.showl = true;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			// 完成跳转
			tiaozhuan() {
				var that = this;
				that.$router.push({
					path: '/min'
				})
			},
			//选中地址
			areaOk(event) {
				this.selectaddress = '';
				for (var item in event) {
					this.selectaddress += event[item].name;
					this.province = event[0].name
					this.city = event[1].name
					this.area = event[2].name
				}
				this.select = false;
			},
			Reset() {
				this.user = '';
				this.tel = '';
				this.user = '';
				this.address = '';
				this.time = '';
				this.fileList = [];
				this.fileLists = [];
				this.contract_number = '';
				this.message = '';
				this.selectaddress = '点击选择城市';
				this.date = '点击选择日期';
			}
		}
	}
</script>

<style scoped>
	.van-tabs--line .van-tabs__wrap {
		height: 3.6875rem !important;
	}

	.backgd {
		width: 100%;
		height: 7rem;
		background-color: #F1452F;
	}

	.van-cell {
		width: 88%;
		text-align: left;
		margin: auto;
		margin-left: 1.3125rem;
		border: none;
	}

	.dropdown {
		padding-top: 3rem;
	}

	.dropdown .esp {
		font-size: 15px;
		color: #fff;
		padding: 0 2rem;
	}

	.main {
		width: 100%;
		position: absolute;
		top: 4rem;
		left: 0;
	}

	.main_from {
		width: 100%;
		overflow: hidden;
		margin: auto;
		padding: 0 0 1rem 0;
		position: relative;
		top: 0px;
	}

	.main_from button {
		padding: 0 0.5rem;
	}

	.main_froms {
		width: 100%;
		overflow: hidden;
		margin: auto;
		padding: 1.2rem 0 1.2rem 0;
		margin-top: 1px;
	}

	.main_froms .default {
		padding: 0.8rem 0 0 2.2rem;
	}

	.van-uploader {
		display: block;
	}

	.main_froms .default .p {
		font-size: 14px;
		text-align: left;
		margin-bottom: 0.25rem;
	}

	.main_froms .tips {
		font-size: 0.75rem;
		color: #c9c9c9;
		margin-bottom: 1rem;
	}

	.defaults {
		width: 88%;
		background-color: #f6f6f6;
		border-radius: 0.5rem;
		margin-bottom: 1rem;
		margin-left: 1.3125rem;
		margin: auto;
	}

	.defaults .van-cell {
		background-color: #f6f6f6;
		border-radius: 0.5rem;
	}

	.van-field__word-limit {
		margin-right: 11px;
	}

	.anniu {
		width: 90%;
		margin: auto;
		display: flex;
		justify-content: space-between;
		margin-top: 3rem;
	}

	.anniu button {
		width: 45%;
		height: 2.5rem;
		line-height: 2.5rem;
		border-radius: 3rem;
		margin-bottom: 1rem;
	}

	.xiabianj {
		margin-top: 1rem;
	}

	.pos {
		font-size: 14px;
		text-align: left;
		margin-left: 2.1rem;
		margin-bottom: 0.5rem;
		margin-top: 0.3125rem;
	}

	.shurulan {
		height: 2rem;
		font-size: 12px;
		position: absolute;
		top: -0.625rem;
		left: -2.34rem;
	}

	.shurulan i {
		font-size: 0.75rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/aftersale/aftersale.vue